<template>
  <v-app id="inspire">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {};
</script>

<style scoped>
#inspire {
  background: none;
  background-color: var(--v-light-base);
}
</style>
